/**
 * Two Pi.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
export const PI_2 = Math.PI * 2;

/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
export const RAD_TO_DEG = 180 / Math.PI;

/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
export const DEG_TO_RAD = Math.PI / 180;